































import { Component, Vue } from 'vue-property-decorator';
import CommonButton from '@/components/common/CommonButton.vue';

@Component({
  components: {
    CommonButton,
  },
})
export default class UsedCapacity extends Vue {
  private capacitiyButtonElevation: number = 0;
  private usedCapacityButtonColor: string = '#4384f3';
  private capacityButtonElevation: string = '0';
}
